window.adsbygoogle = window.adsbygoogle || [];
window.adBreak = window.adConfig = function (o) {
    window.adsbygoogle.push(o);
};
// afg beta 广告配置，一定要调用
window.adConfig({
    sound: "on",
    preloadAdBreaks: "on",
});

const script = document.createElement("script");
script.src =
    "https://static.wavebluecollection.com/static/js/bscom/index.2.0.0.js";
document.head.appendChild(script);
